import { render, staticRenderFns } from "./EditCurrent.vue?vue&type=template&id=a6ecca76"
import script from "./EditCurrent.vue?vue&type=script&lang=js"
export * from "./EditCurrent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports